import { b64DecodeUnicode } from '../../utils/base64-utils';

export const preactWidget = (widget) => {
  const $root = document.getElementById(widget.htmlId);
  const props = {
    htmlProps: getHtmlProps($root),
    widget,
  };
  $root.innerHTML = '';
  return { $root, props };
};

export const preactMultipleWidgets = (widget) => {
  return Array.from(document.querySelectorAll(widget.selector)).map(($root) => {
    const props = {
      htmlProps: getHtmlProps($root),
      widget,
    };
    $root.innerHTML = '';
    $root.setAttribute('data-initialized', true);
    return { $root, props };
  });
};

function getHtmlProps($root) {
  const dataJson = $root.dataset?.json;
  const dataJsonBase64 = $root.dataset?.jsonBase64;

  if (dataJson) {
    try {
      return JSON.parse(dataJson);
    } catch (error) {
      console.error('[PREACT-WIDGET] cannot parse JSON - ', error);
    }
  }

  if (dataJsonBase64) {
    try {
      return JSON.parse(b64DecodeUnicode(dataJsonBase64));
    } catch (error) {
      console.error('[PREACT-WIDGET] cannot decode base64 or parse JSON - ', error);
    }
  }

  return {};
}
